export default __webpack_public_path__ + "static/media/calendericon.096ec9d7.svg";